import React from 'react';

import Typography from '@mui/material/Typography';
import Fab from '@mui/material/Fab';
import DeleteIcon from '@mui/icons-material/Delete';


const User = (props) => {

	function del(index){
		 props.removeUserHandler(index);
	}

	return (
		
		<Typography gutterBottom variant="h4" component="div">
	        {props.u.name + ' (' + props.u.age + ' years old) '}
	        
	        <Fab size="small" variant="contained" color="error" 
	         onClick={() => del(props.i)}>
	           <DeleteIcon />
	        </Fab>

	     </Typography>
	)
}

export default User